// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"433":"769c0417","542":"1ca34d52","782":"53f5b7c8"}[chunkId] + ".chunk.css";
};